import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=f3a405a0&scoped=true"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"
import style0 from "./subItem.vue?vue&type=style&index=0&id=f3a405a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a405a0",
  null
  
)

export default component.exports